/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reps: NonNullable<unknown> }} Plan_Dose_Reps_OnlyInputs */

const en_us2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} reps`)
};

const pt_br2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
};

const es_419_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} repeticiones`)
};

const pt_pt2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
};

const fr_fr2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} répétitions`)
};

const de_de2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} Wdh.`)
};

const it_it2_plan_dose_reps_only = /** @type {(inputs: Plan_Dose_Reps_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reps} ripetizioni`)
};

/**
* | output |
* | --- |
* | "{reps} reps" |
*
* @param {Plan_Dose_Reps_OnlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_dose_reps_only = /** @type {((inputs: Plan_Dose_Reps_OnlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dose_Reps_OnlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_dose_reps_only(inputs)
	if (locale === "es-419") return es_419_plan_dose_reps_only(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_dose_reps_only(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_dose_reps_only(inputs)
	if (locale === "de-DE") return de_de2_plan_dose_reps_only(inputs)
	if (locale === "it-IT") return it_it2_plan_dose_reps_only(inputs)
	return en_us2_plan_dose_reps_only(inputs)
});
export { plan_dose_reps_only as "plan.dose_reps_only" }